<template>
  <PageBreadcrumb
    :crumbs="[{
      label: 'Gestione Partecipanti',
      link: '/partecipanti'
    }, {
      label: form.uuid ? 'Modifica Partecipante' : 'Aggiungi nuova Partecipante'
    }]"
  />
  <form autocomplete="off">
    <InputText
      v-model="form.name"
      :error-fields="errorFields"
      name="name"
      :submitted="submitted"
    >
      Nome
    </InputText>

    <InputText
      v-model="form.email"
      :error-fields="errorFields"
      name="email"
      :submitted="submitted"
    >
      Email
    </InputText>

    <InputText
      v-model="form.address"
      :error-fields="errorFields"
      name="address"
      :submitted="submitted"
    >
      Indirizzo
    </InputText>

    <InputText
      v-model="form.city"
      :error-fields="errorFields"
      name="city"
      :submitted="submitted"
    >
      Città
    </InputText>

    <InputText
      v-model="form.zip"
      :error-fields="errorFields"
      name="zip"
      :submitted="submitted"
    >
      CAP
    </InputText>

    <InputText
      v-model="form.province"
      :error-fields="errorFields"
      name="province"
      :submitted="submitted"
    >
      Provincia
    </InputText>

    <LanguageInputSelect
      v-model="form.language"
      :error-fields="errorFields"
      name="language"
      :submitted="submitted"
    >
      Lingua
    </LanguageInputSelect>

    <BottlerInputSelect
      v-model="form.bottlerUuid"
      :error-fields="errorFields"
      name="bottlerUuid"
      :submitted="submitted"
    >
      Imbottigliatore  
    </BottlerInputSelect>

    <AffiliateInputSelect
      v-model="form.affiliateUuid"
      :error-fields="errorFields"
      name="affiliateUuid"
      :submitted="submitted"
    >
      Accreditato  
    </AffiliateInputSelect>

    <InputInteger
      v-model="form.maxProductPercentage"
      :error-fields="errorFields"
      name="maxProductPercentage"
      :submitted="submitted"
    >
      Percentuale Massima per Prodotto
    </InputInteger>

    <InputInteger
      v-model="form.maxCategoryPercentage"
      :error-fields="errorFields"
      name="maxCategoryPercentage"
      :submitted="submitted"
    >
      Percentuale Massima per Categoria
    </InputInteger>

    <InputTextarea
      v-model="form.delegatedBy"
      :error-fields="errorFields"
      name="delegatedBy"
      :submitted="submitted"
    >
      Per conto di
    </InputTextarea>

    <InputBoolean
      v-model="form.auctionDisabled"
      :error-fields="errorFields"
      name="auctionDisabled"
      :submitted="submitted"
    >
      Partecipazione aste disattivata
    </InputBoolean>

    <InputTextarea
      v-model="form.notes"
      :error-fields="errorFields"
      name="notes"
      :submitted="submitted"
    >
      Note
    </InputTextarea>

    <SubmitButtons
      :create-and-back="createAndBack"
      :create-and-stay="createAndStay"
      :mode="form.uuid ? 'update' : 'create'"
      :pending="pending"
      :update-and-back="updateAndBack"
      :update-and-stay="updateAndStay"
    />
  </form>
</template>

<script setup>
import { reactive } from 'vue'

import AffiliateInputSelect from '@/components/form/AffiliateInputSelect.vue';
import BottlerInputSelect from '@/components/form/BottlerInputSelect.vue';
import InputBoolean from '@/components/form/InputBoolean.vue';
import InputInteger from '@/components/form/InputInteger.vue';
import InputText from '@/components/form/InputText.vue';
import InputTextarea from '@/components/form/InputTextarea.vue';
import LanguageInputSelect from '@/components/form/LanguageInputSelect.vue';
import SubmitButtons from '@/components/form/SubmitButtons.vue';
import PageBreadcrumb from '@/components/PageBreadcrumb.vue';
import useAxios from '@/composables/axios';
import useForm from '@/composables/form';

const props = defineProps({
  id: {
    required: false,
    type: String,
    default: null
  }
})

const axios = useAxios()

let form = reactive({ 
  name: '',
  email: '',
  address: '',
  city: '',
  cap: '',
  province: '',
  maxProductPercentage: 100,
  maxCategoryPercentage: 100,
  affiliateUuid: null,
  delegatedBy: '',
  auctionDisabled: false,
  bottlerUuid: null,
  notes: ''
})

if (props.id) {
  const resp = await axios.get('/company/' + props.id);
  form = reactive(resp.data)
}

const rules = {
  name: {
    type: 'string',
    max: 64,
    required: true
  },
  email: {
    type: 'email',
    max: 255,
    required: false
  },
  address: {
    type: 'string',
    max: 64
  },
  city: {
    type: 'string',
    max: 64
  },
  zip: {
    type: 'string',
    max: 64
  },
  province: {
    type: 'string',
    max: 64
  },
  maxProductPercentage: {
    type: 'integer',
    required: true,
    min: 0,
    max: 100
  },
  maxCategoryPercentage: {
    type: 'integer',
    required: true,
    min: 0,
    max: 100
  },
  affiliateUuid: {
    type: 'string',
    required: true
  }
}
const { submitted, pending, errorFields, createAndBack, createAndStay, updateAndBack, updateAndStay } = useForm(form, 'company', rules, {
  create: 'Partecipante creata con successo',
  update: 'Partecipante modificata con successo'
}, '/partecipanti', () => {
  form.name = '';
  form.maxProductPercentage = 100;
  form.maxCategoryPercentage = 100;
  form.affiliateUuid = null;
  form.delegatedBy = '';
  form.auctionDisabled = false;
  form.bottlerUuid = null;
  form.notes = '';
})

</script>
   
